app.controller("SudoAddGradesExportController", [
    "$scope", "$uibModalInstance", "SudoUtilsService", "SysParam", "StaticData", "toastr",
    function ($scope, $uibModalInstance, SudoUtilsService, SysParam, StaticData, toastr) {

        var now = new Date();
        $scope.years = _.range(2017, now.getFullYear() + 1);
        $scope.year = now.getFullYear().toString();
        $scope.season = now.getMonth() < 7 ? 'spring' : 'autumn';
        $scope.filterSeason = $scope.year + '-' + $scope.season;

        SysParam.getSysParam('currentSeason').then(function (param) {
            if (!$scope.filterSeason) $scope.filterSeason = param.value;
        });

        StaticData.getItemsByKey("subject_seasons").then(function (seasons) {
            $scope.seasons = [].concat(seasons);
            $scope.seasonsMap = _.keyBy($scope.seasons, '_id');

            $scope.filterSeasons = [];
            $scope.years.forEach(function (year) {
                $scope.seasons.forEach(function (season) {
                    $scope.filterSeasons.push({
                        _id: year + '-' + season._id,
                        name: year + ' ' + season.name
                    })
                })
            })
        });


        $scope.submit = function () {
            SudoUtilsService.addGradesExport({season: $scope.filterSeason}).then(function () {
                toastr.success('მოთხოვნა ექსპორტზე მიღებულია');
                $uibModalInstance.close();
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

    }
]);